var _circle, _rect, _rect2, _circle2, _circle3, _g, _circle4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSetUpComplete = function SvgSetUpComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 149 148",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.494,
    cy: 74,
    r: 74,
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.548,
    height: 103.166,
    x: 39,
    y: 22,
    fill: "currentColor",
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 71.548,
    height: 103.166,
    x: 39,
    y: 22,
    stroke: "currentColor",
    strokeWidth: 4,
    rx: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.775,
    cy: 61.209,
    r: 24.399,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "set-up-complete_svg__a",
    style: {
      maskType: "alpha"
    },
    width: 50,
    height: 50,
    x: 50,
    y: 36,
    maskUnits: "userSpaceOnUse"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.775,
    cy: 61.209,
    r: 24.399,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    mask: "url(#set-up-complete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.956 84.519a.567.567 0 01-.566.565.567.567 0 01-.566-.566c0-.31.255-.565.566-.565.311 0 .566.254.566.566z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.002,
    cy: 87.001,
    r: 20
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.002,
    cy: 55,
    r: 8,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 21.558,
    height: 2.874,
    x: 63.994,
    y: 92.013,
    fill: "currentColor",
    rx: 1.437
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 50.302,
    height: 2.874,
    x: 49.623,
    y: 100.636,
    fill: "currentColor",
    rx: 1.437
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 50.302,
    height: 2.874,
    x: 49.623,
    y: 104.948,
    fill: "currentColor",
    rx: 1.437
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 50.302,
    height: 2.874,
    x: 49.623,
    y: 109.259,
    fill: "currentColor",
    rx: 1.437
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14.606,
    height: 14.606,
    x: 79.811,
    y: 67.811,
    fill: "currentColor",
    rx: 7.303
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 14.606,
    height: 14.606,
    x: 79.811,
    y: 67.811,
    stroke: "currentColor",
    strokeWidth: 1.623,
    rx: 7.303
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.623,
    d: "M83.683 75.568l2.154 1.884 4.46-4.899"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSetUpComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/set-up-complete.33e15ae4e784b415efbcd23d8cc444e1.svg";